import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { selectContenidoEstadosDePago } from 'src/app/store/selectors/content.select';
import { AppState } from 'src/app/store/state/app.state';
import { ContenidoDeEstadoDePago } from 'src/app/pago/models/ContenidoDeEstadoDePago.model';
import { BaseFacade } from 'src/app/pago/services/base-facade/BaseFacade';

@Injectable({
  providedIn: 'root',
})
export class ContenidoEstadoDePagoFacade extends BaseFacade {
  contenidoEstadosDePagos$: Observable<ContenidoDeEstadoDePago[]>;

  constructor(protected store: Store<AppState>) {
    super(store);
    this.contenidoEstadosDePagos$ = this.store.pipe(
      select(selectContenidoEstadosDePago),
      filter(
        (contentEstadosDePagos: ContenidoDeEstadoDePago[]) =>
          !!contentEstadosDePagos
      )
    );
  }
}
